import RestaurantMenuIcon from "@material-ui/icons/RestaurantMenu";
import React from "react";
import {
  AccountCircle,
  Alarm,
  AlternateEmail,
  BarChart,
  Build,
  Category,
  CloudUpload,
  DesktopWindows,
  Edit,
  Fastfood,
  Home,
  House,
  Link as LinkIcon,
  ListAlt,
  LocalOffer,
  Map,
  Payment,
  Print,
  Security,
  Settings,
  Speed,
  Storage,
} from "@material-ui/icons";
import ArticleMenu from "../../components/ArticlesMenu/Articles/ArticleMenu";
import Accounts from "../../screens/Accounts";
import Bestsellers from "../../screens/Bestsellers";
import GastrofixLogs from "../../screens/GastrofixLogs";
import GastrofixApi3Setup from "../../screens/GastrofixApi3Setup";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import MerchantLogo from "../../screens/MerchantLogo";
import TakeawayDeliverySettings from "../../screens/TakeawayDeliverySettings";
import TakeawayDeliveryReporting from "../../screens/TakeawayDeliveryReporting";
import TakeawayDeliveryMarketing from "../../screens/TakeawayDeliveryMarketing";
import TakeawayDeliveryOrders from "../../screens/TakeawayDeliveryOrders";
import Reporting from "../../screens/Reporting";
import QRCodes from "../../screens/QRCodes";
import TimeBlocks from "../../screens/TimeBlocks";
import Pos from "../../screens/Pos";
import TaMerchantCollectionLink from "./TaMerchantCollectionLink";
import TaMerchantLink from "./TaMerchantLink";
import CollectionLink from "./CollectionLink";
import Link from "./Link";
import SpMerchantCollectionLink from "./SpMerchantCollectionLink";
import SpMerchantLink from "./SpMerchantLink";
import InHouseOrders from "../../screens/InHouseOrders";
import InHouseFloorplan from "../../screens/InHouseFloorplan";
import InHouseReporting from "../../screens/InHouseReporting";
import ModifiergroupMenu from "../../components/ArticlesMenu/Modifiergroups/ModifiergroupMenu";
import Menugroups from "../../components/ArticlesMenu/Menugroups/Menugroups";
import Printgroups from "../../components/ArticlesMenu/Printgroups/Printgroups";
import PillarMerchantCollectionLink from "./PillarMerchantCollectionLink";
import PillarMerchantLink from "./PillarMerchantLink";
import PillarReporting from "../../screens/PillarReporting";
import PillarOrders from "../../screens/PillarOrders";
import Subscriptions from "../../screens/Subscriptions";
import InHouseSettings from "../../screens/InHouseSettings";
import TaDeSettings from "../../screens/TaDeSettings";
import GeneralSettings from "../../screens/GeneralSettings";
import Paynl from "../../components/PaymentProviders/Paynl/Paynl";
import PaynlLogo from "../../assets/images/paynl_logo.png";
import TakeawaycomLogo from "../../assets/images/takeawaycom.png";
import UbereatsLogo from "../../assets/images/ubereats.png";
import MerchantLogs from "../../screens/MerchantLogs";
import Printers from "../../screens/Printers";
import Opp from "../../components/PaymentProviders/Opp/Opp";
import OppLogo from "./../../assets/images/opp_logo.svg";
import Hubrise from "../../screens/Hubrise";
import HubriseLogo from "../../assets/images/hubrise_logo.png";
import Arrangements from "../../screens/Arrangements";
import OppInvoices from "../../components/OppInvoices/OppInvoices";
import MaxOrderPerBlock from "../../screens/MaxOrdersPerBlock";
import InhouseGuestRegistration from "../../screens/InhouseGuestRegistration";
import AllOrders from "../../screens/AllOrders";
import Allergens from "../../screens/Allergens";
import Drive from "../../MediaDrive/Drive";
import SelectLocation from "../../screens/SelectLocation";
import Permissions from "../../screens/Permissions";
import SupergroupArticles from "../../components/Supergroups/SupergroupArticles";
import Supergroups from "../../components/Supergroups/Supergroups";
import Takeawaycom from "../../screens/Takeawaycom";
import Woocommerce from "../../screens/Woocommerce";
import Ubereats from "../../screens/Ubereats";
import Paynls from "../../components/PaymentProviders/Paynl/Paynls";

export const ROUTE_URLS = {
  ARTICLES: "/home/:merchantId/articles/articles",
  MODIFIERGROUPS: "/home/:merchantId/articles/options",
};

export function getRoutes(merchantId, taMerchants, spMerchants, pillarMerchants) {
  let taMerchantLinks = taMerchants.map((taMerchant) => {
    return new TaMerchantCollectionLink(
      merchantId,
      taMerchant.name ? taMerchant.name : "Takeaway & Delivery",
      <LocalMallIcon />,
      "/home/:merchantId/takeaway/:taMerchantId",
      "screen.takeaway_delivery",
      taMerchant.id,
      [
        new TaMerchantLink(
          merchantId,
          "settings",
          <Settings />,
          "/home/:merchantId/takeaway/:taMerchantId/settings",
          TaDeSettings,
          null,
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "logo",
          <CloudUpload />,
          "/home/:merchantId/takeaway/:taMerchantId/logo",
          MerchantLogo,
          null,
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "postal_codes",
          <Settings />,
          "/home/:merchantId/takeaway/:taMerchantId/settings_old",
          TakeawayDeliverySettings,
          null,
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "reporting",
          <BarChart />,
          "/home/:merchantId/takeaway/:taMerchantId/reporting",
          TakeawayDeliveryReporting,
          "screen.reporting",
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "orders",
          <Fastfood />,
          "/home/:merchantId/takeaway/:taMerchantId/orders",
          TakeawayDeliveryOrders,
          "screen.orders",
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "marketing",
          <AlternateEmail />,
          "/home/:merchantId/takeaway/:taMerchantId/marketing",
          TakeawayDeliveryMarketing,
          taMerchant.ask_marketing ? "screen.reporting" : "unauthorized",
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "qrcodes",
          <LinkIcon />,
          "/home/:merchantId/takeaway/:taMerchantId/qrcodes",
          QRCodes,
          null,
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "time_blocks",
          <Alarm />,
          "/home/:merchantId/takeaway/:taMerchantId/timeblocks",
          TimeBlocks,
          taMerchant.max_weight_per_time_block > 0 ? null : "unauthorized",
          taMerchant.id
        ),
        new TaMerchantLink(
          merchantId,
          "max_orders_per_block",
          <Speed />,
          "/home/:merchantId/takeaway/:taMerchantId/max_order_per_block",
          MaxOrderPerBlock,
          null,
          taMerchant.id
        ),
      ],
      taMerchant.name ? "Takeaway & Delivery" : null
    );
  });

  let spMerchantLinks = spMerchants.map((spMerchant) => {
    return new SpMerchantCollectionLink(
      merchantId,
      spMerchant.name ? spMerchant.name : "Inhouse",
      <Home />,
      "/home/:merchantId/inhouse/:spMerchantId",
      "screen.inhouse",
      spMerchant.id,
      [
        new SpMerchantLink(
          merchantId,
          "settings",
          <Settings />,
          "/home/:merchantId/inhouse/:spMerchantId/settings",
          InHouseSettings,
          null,
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "Arrangements",
          <Settings />,
          "/home/:merchantId/inhouse/:spMerchantId/arrangements",
          Arrangements,
          "screen.arrangements",
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "logo",
          <CloudUpload />,
          "/home/:merchantId/inhouse/:spMerchantId/logo",
          MerchantLogo,
          null,
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "reporting",
          <BarChart />,
          "/home/:merchantId/inhouse/:spMerchantId/reporting",
          InHouseReporting,
          "screen.reporting",
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "orders",
          <Fastfood />,
          "/home/:merchantId/inhouse/:spMerchantId/orders",
          InHouseOrders,
          "screen.orders",
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "qrcodes",
          <LinkIcon />,
          "/home/:merchantId/inhouse/:spMerchantId/qrcodes",
          QRCodes,
          null,
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "floor_plans",
          <Map />,
          "/home/:merchantId/inhouse/:spMerchantId/floorplans",
          InHouseFloorplan,
          null,
          spMerchant.id
        ),
        new SpMerchantLink(
          merchantId,
          "guest_registration",
          <Edit />,
          "/home/:merchantId/inhouse/:spMerchantId/guest_registration",
          InhouseGuestRegistration,
          null,
          spMerchant.id
        ),
      ],
      spMerchant.name ? "Inhouse" : null
    );
  });

  let pillarMerchantLinks = pillarMerchants.map((pillarMerchant) => {
    return new PillarMerchantCollectionLink(
      merchantId,
      pillarMerchant.name ? pillarMerchant.name : "pillar",
      <DesktopWindows />,
      "/home/:merchantId/pillar/:pillarMerchantId",
      null,
      pillarMerchant.id,
      [
        new PillarMerchantLink(
          merchantId,
          "reporting",
          <BarChart />,
          "/home/:merchantId/pillar/:pillarMerchantId/reporting",
          PillarReporting,
          "screen.reporting",
          pillarMerchant.id
        ),
        new PillarMerchantLink(
          merchantId,
          "orders",
          <Fastfood />,
          "/home/:merchantId/pillar/:pillarMerchantId/orders",
          PillarOrders,
          "screen.orders",
          pillarMerchant.id
        ),
      ]
    );
  });

  let gastrofixRoutes = new CollectionLink(
    merchantId,
    "gastrofix",
    <ListAlt />,
    "/home/:merchantId/gastrofix",
    "screen.gastrofix",
    [
      new Link(
        merchantId,
        "gastrofix_logs",
        <ListAlt />,
        "/home/:merchantId/gastrofix/logs",
        GastrofixLogs,
        "screen.gastrofix_logs"
      ),
      new Link(
        merchantId,
        "gastrofix_api3",
        <ListAlt />,
        "/home/:merchantId/gastrofix/api3",
        GastrofixApi3Setup,
        "screen.gastrofix_api3"
      ),
    ]
  );

  let routes = [
    new CollectionLink(merchantId, "main_articles", <RestaurantMenuIcon />, "/home/:merchantId/articles", "articles", [
      new Link(merchantId, "articles", <RestaurantMenuIcon />, ROUTE_URLS.ARTICLES, ArticleMenu),
      new Link(merchantId, "Labels", <LocalOffer />, "/home/:merchantId/articles/allergens", Allergens),
      new Link(
        merchantId,
        "bestsellers",
        <RestaurantMenuIcon />,
        "/home/:merchantId/articles/bestsellers",
        Bestsellers
      ),
      new Link(merchantId, "option_articles", <RestaurantMenuIcon />, ROUTE_URLS.MODIFIERGROUPS, ModifiergroupMenu),
      new Link(merchantId, "menus", <RestaurantMenuIcon />, "/home/:merchantId/articles/menus", Menugroups),
      new Link(
        merchantId,
        "print_groups",
        <Print />,
        "/home/:merchantId/articles/printgroups",
        Printgroups,
        "screen.printgroups"
      ),
      new Link(
        merchantId,
        "Supergroups",
        <Category />,
        "/home/:merchantId/articles/supergroups",
        Supergroups,
        "screen.supergroups"
      ),
      new Link(
        merchantId,
        "Supergroup Articles",
        <Category />,
        "/home/:merchantId/articles/supergroups_articles",
        SupergroupArticles,
        "screen.supergroups"
      ),
    ]),

    new Link(merchantId, "accounts", <AccountCircle />, "/home/:merchantId/accounts", Accounts, "screen.accounts"),
  ];

  routes = routes.concat(taMerchantLinks);
  routes = routes.concat(spMerchantLinks);
  routes = routes.concat(pillarMerchantLinks);

  routes.push(
    new CollectionLink(
      merchantId,
      "payment_providers",
      <Payment />,
      "/home/:merchantId/paymentproviders",
      "screen.payment_providers",
      [
        new Link(
          merchantId,
          "paynl_provider",
          <img src={PaynlLogo} alt={"Paynl Logo"} style={{ width: 24, height: 24 }} />,
          "/home/:merchantId/paymentproviders/paynl",
          Paynls
        ),
        new Link(
          merchantId,
          "opp_provider",
          <img src={OppLogo} alt={"Opp Logo"} style={{ width: 24, height: 24 }} />,
          "/home/:merchantId/paymentproviders/opp",
          Opp,
          "opp_provider"
        ),
      ]
    )
  );

  routes.push(
    new Link(
      merchantId,
      "subscriptions",
      <Payment />,
      "/home/:merchantId/subscriptions",
      Subscriptions,
      "screen.subscriptions"
    )
  );

  routes.push(new Link(merchantId, "printers", <Print />, "/home/:merchantId/printers", Printers, "screen.printers"));
  routes.push(new Link(merchantId, "Orders", <BarChart />, "/home/:merchantId/orders", AllOrders, "screen.reporting"));
  routes.push(
    new Link(merchantId, "Reporting", <BarChart />, "/home/:merchantId/reporting", Reporting, "screen.reporting")
  );
  routes.push(new Link(merchantId, "general_settings", <Settings />, "/home/:merchantId/settings", GeneralSettings));

  routes.push(new Link(merchantId, "POS", <BarChart />, "/home/:merchantId/pos", Pos, "screen.pos"));
  routes.push(gastrofixRoutes);

  routes.push(
    new Link(merchantId, "merchant_logs", <ListAlt />, "/home/:merchantId/logs", MerchantLogs, "screen.merchant_logs")
  );

  routes.push(
    new Link(
      merchantId,
      "opp_invoices",
      <Payment />,
      "/home/:merchantId/opp_invoices",
      OppInvoices,
      "screen.opp_invoices"
    )
  );

  routes.push(
    new CollectionLink(merchantId, "External tools", <Build />, "/home/:merchantId/external_tools", null, [
      new Link(
        merchantId,
        "",
        <img src={HubriseLogo} alt={"Hubrise Logo"} style={{ height: 24 }} />,
        "/home/:merchantId/external_tools/hubrise",
        Hubrise,
        "hubrise"
      ),
      new Link(
        merchantId,
        "Takeaway.com",
        <img src={TakeawaycomLogo} alt={"Takeaway.com"} style={{ height: 24 }} />,
        "/home/:merchantId/external_tools/takeawaycom",
        Takeawaycom,
        "takeaway.com"
      ),new Link(
        merchantId,
        "Uber Eats",
        <img src={UbereatsLogo} alt={"Ubereats"} style={{ height: 24 }} />,
        "/home/:merchantId/external_tools/ubereats",
        Ubereats,
        "ubereats"
      ),
      new Link(
        merchantId,
        "Woocommerce",
        null,
        "/home/:merchantId/external_tools/woocommerce",
        Woocommerce,
        "woocommerce"
      ),
    ])
  );

  return routes;
}

export function getGeneralRoutes() {
  const routes = [];
  routes.push(new Link(null, "Merchants", <House />, "/select", SelectLocation));
  routes.push(new Link(null, "Drive", <Storage />, "/storage", Drive, "drive"));
  routes.push(new Link(null, "Permissions", <Security />, "/permissions", Permissions, "screen.permissions"));
  return routes;
}
